import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-imprint',
    templateUrl: './imprint-page.component.html',
    styleUrls: ['./imprint-page.component.scss'],
    standalone: false
})
export class ImprintPageComponent {
  constructor() { }
}
